import { SvgIconProps } from '@mui/material';

// ----------------------------------------------------------------------

// Using for Checkbox
export function CheckboxIcon(props: SvgIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" {...props}>
      <rect x="0.5" y="0.517578" width="19" height="19" rx="1.5" fill="white" />
      <rect
        x="0.5"
        y="0.517578"
        width="19"
        height="19"
        rx="1.5"
        stroke="#B7BBC2"
      />
    </svg>
  );
}

export function CheckboxCheckedIcon(props: SvgIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" {...props}>
      <rect y="0.0175781" width="20" height="20" rx="2" fill="black" />
      <path
        d="M14.9746 6.24023L8.57821 13.6275L4.97461 10.0239"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BlueCheckboxCheckedIcon(props: SvgIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" {...props}>
      <rect y="0.0175781" width="20" height="20" rx="2" fill="#0066CC" />
      <g transform="translate(8, 6)">
        <path
          d="M6.7461 0.664062L0.07943 7.33073L-3.25391 3.9974"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function GrayArrowDown(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_1478_48734)">
        <path
          d="M7 10L12 15L17 10"
          stroke="#34383D"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1478_48734">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GrayArrowUp(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_1478_22366)">
        <path
          d="M7 14.5L12 9.5L17 14.5"
          stroke="black"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1478_22366">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GrayArrowLeft(props: SvgIconProps) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#E7E9EC" />
      <path
        d="M13 8L21 16L13 24"
        stroke="#5F636B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GrayDoubleArrowLeft(props: SvgIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 17" fill="none" {...props}>
      <path
        d="M7 14.7598L0.999999 7.75977L7 0.759766"
        stroke="#5F636B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14.7598L8 7.75977L14 0.759766"
        stroke="#5F636B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GrayDoubleArrowRight(props: SvgIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 17" fill="none" {...props}>
      <path
        d="M9 15.5098L15 8.50977L9 1.50977"
        stroke="#5F636B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 15.5098L7 8.50977L1 1.50977"
        stroke="#5F636B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CircleDeleteIcon(props: SvgIconProps) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" {...props}>
      <circle cx="8.60352" cy="8.41406" r="8" fill="#D4D7DB" />
      <path
        d="M11.0029 6.01367L6.203 10.8137"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.20312 6.01367L11.0031 10.8137"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SearchIcon(props: SvgIconProps) {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="M16.25 16.6641L13.2339 13.648M13.2339 13.648C14.2393 12.6427 14.8611 11.2538 14.8611 9.71965C14.8611 6.65139 12.3738 4.16406 9.30556 4.16406C6.23731 4.16406 3.75 6.65139 3.75 9.71965C3.75 12.7879 6.23731 15.2752 9.30556 15.2752C10.8397 15.2752 12.2286 14.6534 13.2339 13.648Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SelectArrow(props: SvgIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      stroke="black"
      fill="none"
      {...props}
    >
      <g id="20 / Arrow01">
        <path
          id="Vector 266"
          d="M5.83301 8.33301L9.99967 12.4997L14.1663 8.33301"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function WhiteClose(props: SvgIconProps) {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" {...props}>
      <g id="shape">
        <path
          id="Vector 46"
          d="M8.75 1.25L1.25011 8.75"
          stroke="white"
          strokeWidth="0.857143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 47"
          d="M1.25 1.25L8.74989 8.75"
          stroke="white"
          strokeWidth="0.857143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function GrayClose(props: SvgIconProps) {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" {...props}>
      <path
        d="M8.75 1.25L1.25011 8.75"
        stroke="#888D96"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 1.25L8.74989 8.75"
        stroke="#888D96"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const WorkFavoriteDefault = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M8.24959 0.851225C8.41484 0.516388 8.89231 0.516389 9.05756 0.851225L11.1968 5.18572C11.2624 5.31869 11.3892 5.41085 11.536 5.43217L16.3194 6.12724C16.6889 6.18093 16.8364 6.63503 16.569 6.89566L13.1077 10.2696C13.0016 10.3731 12.9531 10.5222 12.9782 10.6684L13.7953 15.4324C13.8584 15.8005 13.4721 16.0811 13.1416 15.9073L8.86321 13.6581C8.73197 13.5891 8.57518 13.5891 8.44393 13.6581L4.16553 15.9073C3.83502 16.0811 3.44875 15.8005 3.51187 15.4324L4.32897 10.6684C4.35404 10.5222 4.30558 10.3731 4.19941 10.2696L0.738102 6.89566C0.470719 6.63503 0.618265 6.18093 0.987779 6.12724L5.77118 5.43217C5.91792 5.41085 6.04476 5.31869 6.11039 5.18572L8.24959 0.851225Z"
        stroke="#888D96"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function FavoriteDefault(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M8.59529 1.57095C8.76054 1.23612 9.23801 1.23612 9.40326 1.57095L11.5425 5.90545C11.6081 6.03841 11.7349 6.13057 11.8817 6.1519L16.6651 6.84697C17.0346 6.90066 17.1821 7.35476 16.9148 7.61539L13.4534 10.9893C13.3473 11.0928 13.2988 11.2419 13.3239 11.3881L14.141 16.1522C14.2041 16.5202 13.8178 16.8008 13.4873 16.6271L9.20892 14.3778C9.07767 14.3088 8.92088 14.3088 8.78964 14.3778L4.51123 16.6271C4.18073 16.8008 3.79445 16.5202 3.85757 16.1522L4.67467 11.3881C4.69974 11.2419 4.65129 11.0928 4.54511 10.9893L1.08381 7.61539C0.816422 7.35476 0.963968 6.90066 1.33348 6.84697L6.11689 6.1519C6.26362 6.13057 6.39047 6.03841 6.45609 5.90545L8.59529 1.57095Z"
        stroke="#888D96"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FavoriteChecked(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M8.59529 1.57144C8.76054 1.2366 9.23801 1.2366 9.40326 1.57144L11.5425 5.90594C11.6081 6.0389 11.7349 6.13106 11.8817 6.15238L16.6651 6.84745C17.0346 6.90115 17.1821 7.35524 16.9148 7.61588L13.4534 10.9898C13.3473 11.0933 13.2988 11.2424 13.3239 11.3886L14.141 16.1526C14.2041 16.5207 13.8178 16.8013 13.4873 16.6276L9.20892 14.3783C9.07767 14.3093 8.92088 14.3093 8.78964 14.3783L4.51123 16.6276C4.18073 16.8013 3.79445 16.5207 3.85757 16.1526L4.67467 11.3886C4.69974 11.2424 4.65129 11.0933 4.54511 10.9898L1.08381 7.61588C0.816422 7.35524 0.963968 6.90115 1.33348 6.84745L6.11689 6.15238C6.26362 6.13106 6.39047 6.0389 6.45609 5.90594L8.59529 1.57144Z"
        fill="#FEAE00"
        stroke="#FEAE00"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ImportantBadgeIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_1046_6813"
        style={{ maskType: 'alpha' }} // style 속성으로 maskType 설정
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1046_6813)">
        <path
          d="M7.99961 13.7667C7.75705 13.7667 7.50461 13.7471 7.24228 13.7077C6.97983 13.6684 6.72728 13.606 6.48461 13.5206C6.37605 13.4958 6.29228 13.4321 6.23328 13.3296C6.17428 13.227 6.15717 13.1215 6.18194 13.0129C6.20672 12.9043 6.2715 12.8195 6.37628 12.7584C6.48094 12.6973 6.58755 12.6791 6.69611 12.7039C6.89433 12.7671 7.10778 12.8156 7.33644 12.8494C7.56511 12.8832 7.78628 12.9001 7.99994 12.9001C9.22217 12.9001 10.2611 12.4723 11.1166 11.6167C11.9722 10.7612 12.3999 9.72229 12.3999 8.50007C12.3999 7.27784 11.9722 6.23895 11.1166 5.3834C10.2611 4.52784 9.22217 4.10007 7.99994 4.10007C6.77772 4.10007 5.73883 4.52784 4.88328 5.3834C4.02772 6.23895 3.59994 7.27784 3.59994 8.50007C3.59994 8.72684 3.61467 8.94634 3.64411 9.15857C3.67367 9.3709 3.72778 9.57834 3.80644 9.7809C3.84233 9.89623 3.83233 10.0094 3.77644 10.1204C3.72067 10.2314 3.6375 10.3041 3.52694 10.3386C3.4115 10.3745 3.29722 10.3645 3.18411 10.3087C3.071 10.253 2.99722 10.1697 2.96278 10.0591C2.88844 9.80951 2.83161 9.55351 2.79228 9.29107C2.75294 9.02873 2.73328 8.76507 2.73328 8.50007C2.73328 7.76507 2.87094 7.0794 3.14628 6.44307C3.4215 5.80684 3.79733 5.25045 4.27378 4.7739C4.75033 4.29745 5.30672 3.92162 5.94294 3.6464C6.57928 3.37107 7.26494 3.2334 7.99994 3.2334C8.73494 3.2334 9.42061 3.37107 10.0569 3.6464C10.6932 3.92162 11.2496 4.29745 11.7261 4.7739C12.2026 5.25045 12.5784 5.80684 12.8536 6.44307C13.1289 7.0794 13.2666 7.76507 13.2666 8.50007C13.2666 9.23507 13.1289 9.92073 12.8536 10.5571C12.5784 11.1933 12.2026 11.7497 11.7261 12.2262C11.2496 12.7027 10.6932 13.0785 10.0569 13.3537C9.42061 13.6291 8.73483 13.7667 7.99961 13.7667ZM3.07694 13.4064C2.98028 13.3098 2.93194 13.2095 2.93194 13.1052C2.93194 13.0009 2.98028 12.9005 3.07694 12.8039L7.94744 7.9334H6.59994C6.47694 7.9334 6.374 7.89223 6.29111 7.8099C6.20811 7.72768 6.16661 7.62557 6.16661 7.50357C6.16661 7.38157 6.20811 7.27829 6.29111 7.19373C6.374 7.10907 6.47694 7.06673 6.59994 7.06673H8.89744C9.05033 7.06673 9.17783 7.11784 9.27994 7.22007C9.38217 7.32218 9.43328 7.44968 9.43328 7.60257V9.90007C9.43328 10.0231 9.39211 10.126 9.30978 10.2089C9.22755 10.2919 9.12544 10.3334 9.00344 10.3334C8.88144 10.3334 8.77817 10.2919 8.69361 10.2089C8.60894 10.126 8.56661 10.0231 8.56661 9.90007V8.55257L3.67944 13.4231C3.58711 13.5154 3.48778 13.5598 3.38144 13.5564C3.275 13.5531 3.1735 13.5031 3.07694 13.4064Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export function VerticalLine(props: SvgIconProps) {
  return (
    <svg width="2" height="16" viewBox="0 0 2 16" fill="none" {...props}>
      <path d="M1 0.5L0.999999 16.5" stroke="#E7E9EC" strokeLinecap="round" />
    </svg>
  );
}

export function DisplayTypeList(props: SvgIconProps) {
  const { stroke, fill, ...option } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...option}>
      <g clipPath="url(#clip0_3230_128174)">
        <path
          d="M9.94287 7.49921L18.3429 7.49921"
          stroke={stroke || '#B7BBC2'}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="6.24282" cy="7.4" r="1.1" fill={fill || '#B7BBC2'} />
        <path
          d="M9.94287 11.8592L18.3429 11.8592"
          stroke={stroke || '#B7BBC2'}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="6.24282" cy="11.76" r="1.1" fill={fill || '#B7BBC2'} />
        <path
          d="M9.94287 16.2192H18.3429"
          stroke={stroke || '#B7BBC2'}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="6.24282" cy="16.12" r="1.1" fill={fill || '#B7BBC2'} />
      </g>
      <defs>
        <clipPath id="clip0_3230_128174">
          <rect width="24" height="24" rx="3.42857" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DisplayTypeImage(props: SvgIconProps) {
  const { stroke, fill, ...option } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...option}>
      <rect
        x="5.5"
        y="5.5"
        width="5"
        height="5"
        stroke={stroke || '#B7BBC2'}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <rect
        x="13.5"
        y="5.5"
        width="5"
        height="5"
        stroke={stroke || '#B7BBC2'}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <rect
        x="13.5"
        y="13.5"
        width="5"
        height="5"
        stroke={stroke || '#B7BBC2'}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <rect
        x="5.5"
        y="13.5"
        width="5"
        height="5"
        stroke={stroke || '#B7BBC2'}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DisplayTypeChart(props: SvgIconProps) {
  const { stroke, fill, ...option } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...option}>
      <path
        d="M9 9V5H15V9H9Z"
        stroke={stroke || '#B7BBC2'}
        strokeLinejoin="round"
      />
      <path
        d="M4 19V15H10V19H4Z"
        stroke={stroke || '#B7BBC2'}
        strokeLinejoin="round"
      />
      <path
        d="M14 19V15H20V19H14Z"
        stroke={stroke || '#B7BBC2'}
        strokeLinejoin="round"
      />
      <path d="M12 9V12" stroke={stroke || '#B7BBC2'} strokeLinejoin="round" />
      <path
        d="M7 14.5V12H17V14.5"
        stroke={stroke || '#B7BBC2'}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LikeDefaultIcon(props: SvgIconProps) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill={'none'}
      stroke="#888D96"
      {...props}
    >
      <path
        d="M13.5367 7.59631L8.35126 12.7818C8.156 12.977 7.83942 12.977 7.64416 12.7818L2.45871 7.59631C1.02679 6.16438 1.02678 3.84278 2.45871 2.41086C3.89063 0.978933 6.21223 0.978933 7.64416 2.41086C7.83942 2.60612 8.156 2.60612 8.35126 2.41086C9.78319 0.978933 12.1048 0.978933 13.5367 2.41086C14.9686 3.84278 14.9686 6.16438 13.5367 7.59631Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LikeFillIcon(props: SvgIconProps) {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="black" {...props}>
      <path d="M13.8903 7.94986L8.70482 13.1353C8.31429 13.5258 7.68113 13.5258 7.2906 13.1353L2.10515 7.94986C0.47797 6.32267 0.477969 3.68449 2.10515 2.0573C3.73234 0.430118 6.37053 0.430118 7.99771 2.0573C9.6249 0.430118 12.2631 0.430118 13.8903 2.0573C15.5175 3.68449 15.5175 6.32267 13.8903 7.94986Z" />
    </svg>
  );
}

export function CommentDefaultIcon(props: SvgIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill={'none'}
      stroke="#888D96"
      {...props}
    >
      <path
        d="M12.0083 9.90195C12.7115 8.68557 12.9478 7.2548 12.6731 5.8769C12.3984 4.49901 11.6315 3.26825 10.5155 2.41455C9.39964 1.56085 8.0111 1.14261 6.60932 1.23795C5.20755 1.33329 3.88843 1.93569 2.89839 2.93263C1.90835 3.92956 1.31511 5.25283 1.2295 6.65523C1.14389 8.05763 1.57176 9.44324 2.43319 10.5532C3.29461 11.6632 4.53066 12.4215 5.91042 12.6867C7.29019 12.9518 8.7193 12.7056 9.93076 11.994L12.7861 12.7908L12.0083 9.90195Z"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CommentFillIcon(props: SvgIconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="black" {...props}>
      <path d="M13.01 10.4823C13.8538 9.02269 14.1374 7.30576 13.8077 5.65229C13.4781 3.99881 12.5577 2.5219 11.2187 1.49747C9.87956 0.473026 8.21331 -0.0288699 6.53119 0.085539C4.84906 0.199948 3.26612 0.922835 2.07807 2.11916C0.89002 3.31548 0.178135 4.9034 0.0754023 6.58628C-0.0273306 8.26916 0.486116 9.93189 1.51982 11.2638C2.55353 12.5958 4.03679 13.5059 5.69251 13.824C7.34823 14.1422 9.06315 13.8467 10.5169 12.9928L13.9433 13.949L13.01 10.4823Z" />
    </svg>
  );
}

export function PlusIcon(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 1.16699V22.8337"
        stroke="#B7BBC2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16699 12H22.8337"
        stroke="#B7BBC2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SmileIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M10.7602 6.62625C11.0194 6.62625 11.2385 6.53548 11.4175 6.35396C11.5964 6.17243 11.6858 5.95208 11.6858 5.69292C11.6858 5.43361 11.5951 5.21451 11.4137 5.03562C11.2322 4.8566 11.0119 4.76708 10.7527 4.76708C10.4934 4.76708 10.2743 4.85785 10.0954 5.03937C9.91639 5.2209 9.82688 5.44125 9.82688 5.70042C9.82688 5.95972 9.91764 6.17882 10.0992 6.35771C10.2806 6.53673 10.5009 6.62625 10.7602 6.62625ZM5.24729 6.62625C5.5066 6.62625 5.72569 6.53548 5.90458 6.35396C6.08361 6.17243 6.17313 5.95208 6.17313 5.69292C6.17313 5.43361 6.08236 5.21451 5.90083 5.03562C5.71944 4.8566 5.4991 4.76708 5.23979 4.76708C4.98063 4.76708 4.76153 4.85785 4.5825 5.03937C4.40361 5.2209 4.31417 5.44125 4.31417 5.70042C4.31417 5.95972 4.40486 6.17882 4.58625 6.35771C4.76778 6.53673 4.98812 6.62625 5.24729 6.62625ZM8 11.8504C8.79486 11.8504 9.52694 11.6312 10.1962 11.1927C10.8657 10.7541 11.3687 10.1721 11.7052 9.44667H10.875C10.5694 9.96056 10.1632 10.3668 9.65625 10.6654C9.14931 10.964 8.59722 11.1133 8 11.1133C7.40278 11.1133 6.85069 10.964 6.34375 10.6654C5.83681 10.3668 5.43056 9.96056 5.125 9.44667H4.29479C4.63132 10.1721 5.13431 10.7541 5.80375 11.1927C6.47306 11.6312 7.20514 11.8504 8 11.8504ZM8.00271 15.28C6.96563 15.28 5.99056 15.0832 5.0775 14.6896C4.16458 14.296 3.37042 13.7618 2.695 13.0871C2.01958 12.4124 1.48493 11.6189 1.09104 10.7067C0.697014 9.79458 0.5 8.81993 0.5 7.78271C0.5 6.74562 0.696805 5.77055 1.09042 4.8575C1.48403 3.94458 2.01819 3.15042 2.69292 2.475C3.36764 1.79958 4.16111 1.26493 5.07333 0.87104C5.98542 0.477013 6.96007 0.279999 7.99729 0.279999C9.03438 0.279999 10.0094 0.476805 10.9225 0.870416C11.8354 1.26403 12.6296 1.79819 13.305 2.47292C13.9804 3.14764 14.5151 3.94111 14.909 4.85333C15.303 5.76542 15.5 6.74007 15.5 7.77729C15.5 8.81437 15.3032 9.78944 14.9096 10.7025C14.516 11.6154 13.9818 12.4096 13.3071 13.085C12.6324 13.7604 11.8389 14.2951 10.9267 14.689C10.0146 15.083 9.03993 15.28 8.00271 15.28ZM8 14.4467C9.86111 14.4467 11.4375 13.8008 12.7292 12.5092C14.0208 11.2175 14.6667 9.64111 14.6667 7.78C14.6667 5.91889 14.0208 4.3425 12.7292 3.05083C11.4375 1.75917 9.86111 1.11333 8 1.11333C6.13889 1.11333 4.5625 1.75917 3.27083 3.05083C1.97917 4.3425 1.33333 5.91889 1.33333 7.78C1.33333 9.64111 1.97917 11.2175 3.27083 12.5092C4.5625 13.8008 6.13889 14.4467 8 14.4467Z"
        fill="#888D96"
      />
    </svg>
  );
}

export function ImportantNewIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3428_18615)">
        <path
          d="M24.475 2.25527C24.475 1.60019 24.0789 1.00605 23.4695 0.752143C22.8601 0.498237 22.1644 0.640425 21.6972 1.10253L19.4832 3.32167C17.0457 5.75917 13.7398 7.13027 10.2918 7.13027H9.84998H8.22498H3.34998C1.5574 7.13027 0.0999756 8.58769 0.0999756 10.3803V15.2553C0.0999756 17.0478 1.5574 18.5053 3.34998 18.5053V25.0053C3.34998 25.9041 4.07615 26.6303 4.97498 26.6303H8.22498C9.1238 26.6303 9.84998 25.9041 9.84998 25.0053V18.5053H10.2918C13.7398 18.5053 17.0457 19.8764 19.4832 22.3139L21.6972 24.5279C22.1644 24.9951 22.8601 25.1322 23.4695 24.8783C24.0789 24.6244 24.475 24.0353 24.475 23.3752V15.885C25.4195 15.4381 26.1 14.2346 26.1 12.8178C26.1 11.401 25.4195 10.1975 24.475 9.75058V2.25527ZM21.225 6.15019V12.8178V19.4853C18.239 16.7685 14.3441 15.2553 10.2918 15.2553H9.84998V10.3803H10.2918C14.3441 10.3803 18.239 8.86699 21.225 6.15019Z"
          fill="#3F4254"
        />
      </g>
      <defs>
        <clipPath id="clip0_3428_18615">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(0.0999756 0.629883)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function InterviewNewIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      {...props}
    >
      <g mask="url(#mask0_3826_5713)">
        <path
          d="M21.3756 20.6475C21.3756 20.6475 21.0365 20.9866 20.3584 21.6647C19.6803 22.3428 18.3725 22.6819 16.435 22.6819C14.4975 22.6819 12.8506 22.0038 11.4943 20.6475C10.1381 19.2913 9.45996 17.6444 9.45996 15.7069C9.45996 13.7694 10.1381 12.1225 11.4943 10.7663C12.8506 9.41005 14.4975 8.73193 16.435 8.73193C18.3725 8.73193 20.0193 9.41005 21.3756 10.7663C22.7318 12.1225 23.41 13.7694 23.41 15.7069C23.41 17.6444 22.7318 19.2913 21.3756 20.6475ZM19.7287 12.4131C19.7287 12.4131 19.5027 12.1871 19.0506 11.735C18.5985 11.2829 17.7266 11.0569 16.435 11.0569C15.1433 11.0569 14.0454 11.509 13.1412 12.4131C12.237 13.3173 11.785 14.4152 11.785 15.7069C11.785 16.9986 12.237 18.0965 13.1412 19.0006C14.0454 19.9048 15.1433 20.3569 16.435 20.3569C17.7266 20.3569 18.8245 19.9048 19.7287 19.0006C20.6329 18.0965 21.085 16.9986 21.085 15.7069C21.085 14.4152 20.6329 13.3173 19.7287 12.4131ZM7.90996 31.2069H21.5693C22.086 32.0788 22.7157 32.8538 23.4584 33.5319H7.90996C7.26413 33.5319 6.71517 33.3058 6.26309 32.8538C5.811 32.4017 5.58496 31.8527 5.58496 31.2069V29.9475C5.58496 28.1715 6.22272 26.6457 7.49824 25.3702C8.77376 24.0946 10.2995 23.4569 12.0756 23.4569C12.4954 23.4569 13.117 23.5861 13.9404 23.8444C14.7639 24.1027 15.5954 24.2319 16.435 24.2319C17.2745 24.2319 18.1061 24.1027 18.9295 23.8444C19.7529 23.5861 20.3907 23.4569 20.8428 23.4569C20.5844 24.2319 20.423 25.023 20.3584 25.8303C20.2938 25.8626 20.1162 25.9191 19.8256 25.9999C19.535 26.0806 19.2524 26.1613 18.9779 26.242C18.7035 26.3228 18.3321 26.3954 17.8639 26.46C17.3956 26.5246 16.9193 26.5569 16.435 26.5569C15.4662 26.5569 14.5217 26.4277 13.6014 26.1694C12.6811 25.9111 12.1725 25.7819 12.0756 25.7819C10.9454 25.7819 9.96855 26.1936 9.14512 27.017C8.32168 27.8405 7.90996 28.8173 7.90996 29.9475V31.2069ZM24.6693 21.6163C24.6693 21.6163 25.0084 21.2772 25.6865 20.5991C26.3646 19.9209 27.6725 19.5819 29.61 19.5819C31.5475 19.5819 33.1943 20.26 34.5506 21.6163C35.9068 22.9725 36.585 24.6194 36.585 26.5569C36.585 28.4944 35.9068 30.1413 34.5506 31.4975C33.1943 32.8538 31.5475 33.5319 29.61 33.5319C27.6725 33.5319 26.0256 32.8538 24.6693 31.4975C23.3131 30.1413 22.635 28.4944 22.635 26.5569C22.635 24.6194 23.3131 22.9725 24.6693 21.6163ZM32.71 26.8475V26.2663C32.71 25.9433 32.5485 25.7819 32.2256 25.7819H30.385V23.1663C30.385 22.8433 30.2235 22.6819 29.9006 22.6819H29.3193C28.9964 22.6819 28.835 22.8433 28.835 23.1663V26.8475C28.835 27.1704 28.9964 27.3319 29.3193 27.3319H32.2256C32.5485 27.3319 32.71 27.1704 32.71 26.8475Z"
          fill="#3F4254"
        />
      </g>
      <path
        d="M37.64 27.031C37.64 22.8612 34.2598 19.481 30.09 19.481C25.9203 19.481 22.54 22.8612 22.54 27.031C22.54 31.2007 25.9203 34.581 30.09 34.581C34.2598 34.581 37.64 31.2007 37.64 27.031Z"
        fill="#3F4254"
      />
      <path
        d="M37.64 27.031C37.64 22.8612 34.2598 19.481 30.09 19.481C25.9203 19.481 22.54 22.8612 22.54 27.031C22.54 31.2007 25.9203 34.581 30.09 34.581C34.2598 34.581 37.64 31.2007 37.64 27.031Z"
        stroke="#F7F7F7"
        strokeWidth="2"
      />
      <path
        d="M32.7699 30.5317H31.5099L28.6569 26.2207V30.5317H27.3969V24.2407H28.6569L31.5099 28.5607V24.2407H32.7699V30.5317Z"
        fill="#F7F7F7"
      />
    </svg>
  );
}

export function BirthDayNewIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="27"
      viewBox="0 0 23 27"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3428_18630)">
        <path
          d="M9.8231 4.04317C9.8231 3.57741 10.0892 3.11165 10.6215 2.6459C11.1538 2.18014 11.42 1.58132 11.42 0.849415C11.7527 0.849415 12.102 1.15715 12.4679 1.77261C12.8339 2.38807 13.0169 3.01185 13.0169 3.64395C13.0169 4.27604 12.8671 4.76675 12.5677 5.11607C12.2683 5.46538 11.8857 5.64004 11.42 5.64004C10.9875 5.64004 10.6132 5.48202 10.2972 5.16597C9.98113 4.84992 9.8231 4.47565 9.8231 4.04317ZM17.8075 5.64004C17.375 5.64004 17.0007 5.48202 16.6847 5.16597C16.3686 4.84992 16.2106 4.47565 16.2106 4.04317C16.2106 3.57741 16.4767 3.11165 17.009 2.6459C17.5413 2.18014 17.8075 1.58132 17.8075 0.849415C18.1402 0.849415 18.4895 1.15715 18.8554 1.77261C19.2214 2.38807 19.4044 3.01185 19.4044 3.64395C19.4044 4.27604 19.2546 4.76675 18.9552 5.11607C18.6558 5.46538 18.2732 5.64004 17.8075 5.64004ZM22.5981 14.4229V26.3994H0.241852V14.4229C0.241852 13.7575 0.474729 13.1919 0.940485 12.7262C1.40624 12.2604 1.9718 12.0275 2.63716 12.0275H3.83482V6.43848H6.23013V12.0275H10.2223V6.43848H12.6176V12.0275H16.6098V6.43848H19.0051V12.0275H20.2028C20.8682 12.0275 21.4337 12.2604 21.8995 12.7262C22.3652 13.1919 22.5981 13.7575 22.5981 14.4229ZM2.63716 14.7223V17.5667C3.16946 17.9992 3.61858 18.2154 3.98453 18.2154C4.31721 18.2154 4.81623 17.9493 5.4816 17.417C6.14696 16.8847 6.8955 16.6186 7.7272 16.6186C8.52564 16.6186 9.25754 16.8847 9.92291 17.417C10.5883 17.9493 11.0873 18.2154 11.42 18.2154C11.7527 18.2154 12.2517 17.9493 12.917 17.417C13.5824 16.8847 14.3309 16.6186 15.1627 16.6186C15.7947 16.6186 16.327 16.7516 16.7595 17.0178C17.192 17.2839 17.5663 17.5501 17.8823 17.8162C18.1984 18.0824 18.5394 18.2154 18.9053 18.2154C19.238 18.2154 19.6705 17.9992 20.2028 17.5667V14.7223C20.2028 14.5227 20.103 14.4229 19.9034 14.4229H2.93658C2.73697 14.4229 2.63716 14.5227 2.63716 14.7223ZM20.2028 24.0041V19.962C19.8036 20.1284 19.3711 20.2115 18.9053 20.2115C18.0736 20.2115 17.3251 19.9454 16.6597 19.4131C15.9944 18.8808 15.4953 18.6146 15.1627 18.6146C14.83 18.6146 14.3309 18.8808 13.6656 19.4131C13.0002 19.9454 12.2517 20.2115 11.42 20.2115C10.6215 20.2115 9.88132 19.9454 9.19932 19.4131C8.51732 18.8808 8.02662 18.6146 7.7272 18.6146C7.36125 18.6146 6.84559 18.8808 6.18023 19.4131C5.51487 19.9454 4.78297 20.2115 3.98453 20.2115C3.4855 20.2115 3.03638 20.1284 2.63716 19.962V24.0041H20.2028ZM5.03248 5.64004C4.59999 5.64004 4.22572 5.48202 3.90967 5.16597C3.59363 4.84992 3.4356 4.47565 3.4356 4.04317C3.4356 3.57741 3.70175 3.11165 4.23404 2.6459C4.76633 2.18014 5.03248 1.58132 5.03248 0.849415C5.36516 0.849415 5.71448 1.15715 6.08043 1.77261C6.44638 2.38807 6.62935 3.01185 6.62935 3.64395C6.62935 4.27604 6.47964 4.76675 6.18023 5.11607C5.88082 5.46538 5.49823 5.64004 5.03248 5.64004Z"
          fill="#3F4254"
        />
      </g>
      <defs>
        <clipPath id="clip0_3428_18630">
          <rect
            width="22.36"
            height="25.55"
            fill="white"
            transform="matrix(1 0 0 -1 0.23999 26.3994)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function FaalNewIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3428_18636)">
        <path
          d="M14.545 7.88291C14.545 8.6902 14.3997 9.4652 14.1091 10.2079C13.8184 10.9506 13.4229 11.5965 12.9223 12.1454C12.4218 12.6944 11.8325 13.1465 11.1544 13.5017L11.6388 22.2688C11.7033 23.0116 11.4692 23.6574 10.9364 24.2063C10.4036 24.7553 9.76583 25.0298 9.02313 25.0298H6.11688C5.37417 25.0298 4.73641 24.7553 4.20359 24.2063C3.67078 23.6574 3.43667 23.0116 3.50125 22.2688L3.98563 13.5017C2.95229 12.9527 2.12886 12.1858 1.51531 11.2009C0.901772 10.216 0.595001 9.10999 0.595001 7.88291C0.595001 6.84958 0.853335 5.04124 1.37 2.45791C1.46688 1.81208 1.78979 1.27926 2.33875 0.859474C2.88771 0.439682 3.54969 0.229786 4.32469 0.229786C4.93823 0.229786 5.48719 0.358953 5.97156 0.617287C6.42365 0.358953 6.95646 0.229786 7.57 0.229786C8.18354 0.229786 8.71636 0.358953 9.16844 0.617287C9.65281 0.358953 10.2018 0.229786 10.8153 0.229786C11.5903 0.229786 12.2523 0.439682 12.8013 0.859474C13.3502 1.27926 13.6731 1.81208 13.77 2.45791C14.2867 5.04124 14.545 6.84958 14.545 7.88291ZM8.7325 11.9032C9.44292 11.7741 10.0565 11.5238 10.5731 11.1524C11.0898 10.7811 11.4934 10.3129 11.7841 9.74775C12.0747 9.18265 12.22 8.56104 12.22 7.88291C12.22 7.68916 12.2039 7.44697 12.1716 7.15635C12.1393 6.86572 12.107 6.5751 12.0747 6.28447C12.0424 5.99385 11.994 5.679 11.9294 5.33994C11.8648 5.00088 11.8083 4.69411 11.7598 4.41963C11.7114 4.14515 11.671 3.88682 11.6388 3.64463C11.6065 3.40244 11.5742 3.21676 11.5419 3.0876L11.4934 2.89385C11.4611 2.66781 11.227 2.55479 10.7911 2.55479C10.3552 2.55479 10.121 2.66781 10.0888 2.89385V8.41572C10.0565 8.67406 9.81427 8.80322 9.36219 8.80322C8.9101 8.80322 8.66792 8.67406 8.63563 8.41572L8.29656 2.89385C8.23198 2.66781 7.98172 2.55479 7.54578 2.55479C7.10984 2.55479 6.87573 2.66781 6.84344 2.89385L6.50438 8.41572C6.47208 8.67406 6.2299 8.80322 5.77781 8.80322C5.32573 8.80322 5.08354 8.67406 5.05125 8.41572V2.89385C5.01896 2.66781 4.78484 2.55479 4.34891 2.55479C3.91297 2.55479 3.67886 2.66781 3.64656 2.89385C3.16219 5.31572 2.92 6.97874 2.92 7.88291C2.92 8.91624 3.23484 9.79619 3.86453 10.5228C4.49422 11.2493 5.34188 11.7095 6.4075 11.9032L5.82625 22.4142C5.79396 22.6079 5.89083 22.7048 6.11688 22.7048H9.02313C9.24917 22.7048 9.34604 22.6079 9.31375 22.4142L8.7325 11.9032ZM19.4856 15.2938C17.2252 13.4855 16.095 11.4027 16.095 9.04541C16.095 6.7527 16.9911 4.71025 18.7833 2.91807C20.5755 1.12588 22.3919 0.229786 24.2325 0.229786C24.9752 0.229786 25.613 0.488119 26.1458 1.00479C26.6786 1.52145 26.945 2.13499 26.945 2.84541V22.4142C26.945 23.1246 26.6786 23.7381 26.1458 24.2548C25.613 24.7715 24.9752 25.0298 24.2325 25.0298H21.52C20.7127 25.0298 20.0427 24.7472 19.5098 24.1821C18.977 23.617 18.7429 22.947 18.8075 22.172L19.4856 15.2938ZM18.42 9.04541C18.42 10.886 19.5825 12.5975 21.9075 14.1798L21.1325 22.4142C21.1002 22.6079 21.2294 22.7048 21.52 22.7048H24.2325C24.4908 22.7048 24.62 22.6079 24.62 22.4142V2.84541C24.62 2.65166 24.4908 2.55479 24.2325 2.55479C23.0377 2.55479 21.7703 3.22484 20.4302 4.56494C19.0901 5.90505 18.42 7.39853 18.42 9.04541Z"
          fill="#3F4254"
        />
      </g>
      <defs>
        <clipPath id="clip0_3428_18636">
          <rect
            width="26.36"
            height="24.8"
            fill="white"
            transform="matrix(1 0 0 -1 0.589996 25.0298)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function NotificationNewIconV2(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2.49479 15.9979L2.495 7.95481C2.4951 3.89262 5.78819 0.599613 9.85038 0.599612C13.9127 0.599611 17.2059 3.89285 17.2058 7.95519L17.2056 15.9979M2.49479 15.9979L17.2056 15.9979M2.49479 15.9979H0.599976M17.2056 15.9979H19.1"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.55025 18.749H13.1495"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NotificationNewIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="26"
      viewBox="0 0 22 26"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3428_18643)">
        <path
          d="M21.5439 17.7642C21.8346 18.0871 21.98 18.4423 21.98 18.8298C21.98 19.2496 21.8346 19.6129 21.5439 19.9196C21.2531 20.2264 20.8816 20.3798 20.4293 20.3798H1.82073C1.52997 20.3798 1.26345 20.3071 1.02115 20.1618C0.778848 20.0165 0.593085 19.8228 0.463859 19.5806C0.334633 19.3384 0.27002 19.0881 0.27002 18.8298C0.27002 18.4423 0.415399 18.0871 0.706158 17.7642C0.738464 17.7319 0.786924 17.6673 0.851537 17.5704C1.33614 17.086 1.71574 16.6501 1.99034 16.2626C2.26495 15.8751 2.56378 15.1405 2.88685 14.0587C3.20991 12.9769 3.37145 11.7256 3.37145 10.3048C3.37145 8.43187 3.95297 6.80114 5.116 5.4126C6.27904 4.02406 7.76514 3.15218 9.5743 2.79697V1.77979C9.5743 1.35999 9.72776 0.996714 10.0347 0.689941C10.3416 0.383171 10.705 0.229786 11.125 0.229786C11.545 0.229786 11.9085 0.383171 12.2154 0.689941C12.5223 0.996714 12.6757 1.35999 12.6757 1.77979V2.79697C13.8711 3.02301 14.9372 3.49124 15.8741 4.20166C16.811 4.91208 17.5459 5.8001 18.079 6.86572C18.6121 7.93135 18.8786 9.0777 18.8786 10.3048C18.8786 11.7256 19.0401 12.9769 19.3632 14.0587C19.6863 15.1405 19.9851 15.8751 20.2597 16.2626C20.5343 16.6501 20.9139 17.086 21.3985 17.5704C21.4631 17.6673 21.5116 17.7319 21.5439 17.7642ZM3.56529 18.0548H18.6847C17.2633 16.1496 16.5525 13.5824 16.5525 10.3532C16.5525 10.3209 16.5525 10.3048 16.5525 10.3048C16.5525 8.81937 16.0195 7.54385 14.9533 6.47822C13.8872 5.4126 12.6111 4.87979 11.125 4.87979C9.63892 4.87979 8.36281 5.4126 7.29669 6.47822C6.23058 7.54385 5.69752 8.81937 5.69752 10.3048C5.69752 10.3048 5.69752 10.3209 5.69752 10.3532C5.69752 13.5824 4.98677 16.1496 3.56529 18.0548ZM13.3057 24.1337C13.3057 24.1337 13.1523 24.283 12.8453 24.5817C12.5384 24.8804 11.965 25.0298 11.125 25.0298C10.285 25.0298 9.55815 24.7311 8.94433 24.1337C8.3305 23.5363 8.02359 22.8017 8.02359 21.9298H14.2264C14.2264 22.8017 13.9195 23.5363 13.3057 24.1337Z"
          fill="#3F4254"
        />
      </g>
      <defs>
        <clipPath id="clip0_3428_18643">
          <rect
            width="21.72"
            height="24.8"
            fill="white"
            transform="matrix(1 0 0 -1 0.265015 25.0298)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PlusButton(props: SvgIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8 1.5V14.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 8H14.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// 소셜 사이드바 그룹 펼침 상태(열린 폴더). 원본 32x28 path 를 24x24 뷰에 맞춰 중앙 정렬.
export function SocialFolderOpenIcon(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g transform="translate(-8.79, -0.75)">
        <path
          d="M28.5539 11.2341V8.02528C28.5539 7.56505 28.1808 7.19195 27.7206 7.19195H20.8149C20.5939 7.19195 20.3819 7.10415 20.2257 6.94787L18.6928 5.41498C18.5365 5.2587 18.3245 5.1709 18.1035 5.1709H12.2083C11.7481 5.1709 11.375 5.54399 11.375 6.00423V19.4955C11.375 19.9557 11.7481 20.3288 12.2083 20.3288H13.5732C14.0335 20.3288 14.4066 19.9557 14.4066 19.4955V19.4694C14.4066 19.3695 14.4246 19.2703 14.4596 19.1768L17.2354 11.7748C17.3574 11.4495 17.6683 11.2341 18.0157 11.2341H29.4188C29.9876 11.2341 30.3892 11.7913 30.2094 12.3309L27.7334 19.759C27.6199 20.0993 27.3015 20.3288 26.9428 20.3288H13.3961"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

// 소셜 사이드바 그룹 접힘 상태/ALL(닫힌 폴더).
export function SocialFolderClosedIcon(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3.37603 9.16698V19.4958C3.37603 19.956 3.74913 20.3291 4.20936 20.3291H19.7202C20.1805 20.3291 20.5536 19.956 20.5536 19.4958V8.02528C20.5536 7.56505 20.1805 7.19195 19.7202 7.19195H12.8839C12.6187 7.19195 12.3644 7.08659 12.1768 6.89906L10.7416 5.46379C10.554 5.27626 10.2997 5.1709 10.0345 5.1709H4.20869C3.74832 5.1709 3.37516 5.54392 3.37532 6.00429C3.37563 6.84826 3.37604 8.16799 3.37603 9.16698Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const DashIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="12"
    viewBox="0 0 4 12"
    fill="none"
    {...props}
  >
    <path d="M3 0H4L1 12H0L3 0Z" fill="#888D96" />
  </svg>
);

// ----------------------------------------------------------------------
// 소셜 2026 디자인 아이콘 (PORTAL-11979). 색은 currentColor 로 부모 color 를 따른다.

// 카테고리 권한 보기/설정 버튼(20x20).
export function SocialPermissionViewIcon(props: SvgIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M11.2912 6.19196C11.2912 7.45433 10.2678 8.47768 9.00544 8.47768C7.74308 8.47768 6.71973 7.45433 6.71973 6.19196C6.71973 4.9296 7.74308 3.90625 9.00544 3.90625C10.2678 3.90625 11.2912 4.9296 11.2912 6.19196Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M8 11.1074C4.58458 11.4017 2.91016 13.2142 2.91016 15.4061C2.91016 15.7874 3.1884 16.0966 3.53163 16.0966H8.00539"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M16 13.5C16 14.8807 14.8807 16 13.5 16M16 13.5C16 12.1193 14.8807 11 13.5 11M16 13.5H17M13.5 16C12.1193 16 11 14.8807 11 13.5M13.5 16V17M11 13.5C11 12.1193 12.1193 11 13.5 11M11 13.5H10M13.5 11V10M15.2678 15.2678C14.2915 16.2441 12.7085 16.2441 11.7322 15.2678M15.2678 15.2678C16.2441 14.2915 16.2441 12.7086 15.2678 11.7323M15.2678 15.2678L15.9749 15.9749M11.7322 15.2678C10.7559 14.2915 10.7559 12.7086 11.7322 11.7323M11.7322 15.2678L11.0251 15.9749M11.7322 11.7323C12.7085 10.756 14.2915 10.756 15.2678 11.7323M11.7322 11.7323L11.0251 11.0252M15.2678 11.7323L15.9749 11.0252"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <circle cx="13.5" cy="13.5" r="0.5" stroke="currentColor" />
    </svg>
  );
}

// 권한 역할 — 관리자(28x28).
export function SocialRoleAdminIcon(props: SvgIconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path
        d="M9.90379 8.88115H10.0187M16.4817 11.5181L22.807 17.8434C22.9945 18.0309 23.0999 18.2853 23.0999 18.5505V22.0999C23.0999 22.6522 22.6522 23.0999 22.0999 23.0999H19.7908V20.6181H17.309V18.1363L14.2522 15.2575C13.2699 16.0246 12.0337 16.4817 10.6908 16.4817C7.49258 16.4817 4.8999 13.889 4.8999 10.6908C4.8999 7.49258 7.49258 4.8999 10.6908 4.8999C13.889 4.8999 16.4817 7.49258 16.4817 10.6908V11.5181Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// 권한 역할 — 사용자(28x28).
export function SocialRoleUserIcon(props: SvgIconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path
        d="M5.47412 21.5687C5.47412 18.2126 8.27793 15.492 14.0075 15.492C19.737 15.492 22.5408 18.2126 22.5408 21.5687C22.5408 22.1026 22.1512 22.5354 21.6707 22.5354H6.34419C5.86366 22.5354 5.47412 22.1026 5.47412 21.5687Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M17.2075 8.66875C17.2075 10.4361 15.7748 11.8688 14.0075 11.8688C12.2401 11.8688 10.8075 10.4361 10.8075 8.66875C10.8075 6.90144 12.2401 5.46875 14.0075 5.46875C15.7748 5.46875 17.2075 6.90144 17.2075 8.66875Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

// 권한 역할 — 카테고리에서 제외(28x28, 고정 빨강 #F55060).
export function SocialRoleExcludeIcon(props: SvgIconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
      <path
        d="M13.2873 15.5503C7.31908 15.5503 4.39844 18.3843 4.39844 21.8802C4.39844 22.4363 4.80421 22.8872 5.30476 22.8872H13.2873M16.6207 8.44271C16.6207 10.2837 15.1283 11.7761 13.2873 11.7761C11.4464 11.7761 9.954 10.2837 9.954 8.44271C9.954 6.60176 11.4464 5.10938 13.2873 5.10938C15.1283 5.10938 16.6207 6.60176 16.6207 8.44271Z"
        stroke="#F55060"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M23.9998 22.5L20.9999 19.5001M20.9999 19.5001L18 16.5002M20.9999 19.5001L18.0002 22.4998M20.9999 19.5001L24 16.5"
        stroke="#F55060"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

// 카테고리/그룹 추가(+) (24x24).
export function SocialAddIcon(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 5.3999V18.5999"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.40039 12H18.6004"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// 더보기(케밥, 세로 점 3개) (24x24).
export function SocialMoreIcon(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="6" r="1.5" fill="currentColor" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      <circle cx="12" cy="18" r="1.5" fill="currentColor" />
    </svg>
  );
}

// 카테고리 항목(미분류/일반) (24x24).
export function SocialCategoryItemIcon(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20 16H4M20 8H4M6.66667 20L9.33333 4M14.6667 20L17.3333 4"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

// 브레드크럼 링크 복사 버튼의 세로 체인(링크) 글리프 (20x20).
// 흰 배경 라운드 사각 + 보더 프레임은 버튼 컨테이너가 그리므로 여기선 체인만 currentColor 로 둔다.
export function SocialLinkCopyIcon(props: SvgIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M12.916 8.41037L12.916 7.66012C12.916 7.27712 12.8406 6.89788 12.694 6.54404C12.5474 6.19019 12.3326 5.86869 12.0618 5.59787C11.791 5.32705 11.4695 5.11222 11.1156 4.96566C10.7618 4.81909 10.3825 4.74365 9.99952 4.74365C9.61652 4.74365 9.23727 4.81909 8.88343 4.96566C8.52958 5.11222 8.20807 5.32705 7.93725 5.59787C7.66643 5.86869 7.4516 6.19019 7.30503 6.54404C7.15847 6.89788 7.08303 7.27712 7.08303 7.66012L7.08303 8.41037"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M7.08301 11.5893L7.08301 12.3394C7.08301 12.7224 7.15845 13.1016 7.30501 13.4555C7.45158 13.8093 7.66641 14.1308 7.93723 14.4016C8.20805 14.6725 8.52956 14.8873 8.88341 15.0339C9.23725 15.1804 9.6165 15.2559 9.9995 15.2559C10.3825 15.2559 10.7618 15.1804 11.1156 15.0339C11.4694 14.8873 11.791 14.6725 12.0618 14.4016C12.3326 14.1308 12.5474 13.8093 12.694 13.4555C12.8406 13.1016 12.916 12.7224 12.916 12.3394L12.916 11.5893"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M9.99902 8.25L9.99902 11.7498"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
